import rsvpModelReducer from '../../helpers/rsvp-model-reducer';
import contactModelReducer from '../../../contacts/helpers/contact-model-reducer.js';

export default class RsvpQuickEditController {
    constructor($uibModalInstance, $scope, $injector, rsvpId) {
        this.scope = $scope;
        this.modalInstance = $uibModalInstance;
        this.injector = $injector;
        this.rsvpId = rsvpId;
        this.hideCustomRsvpCode = true;

        this.error = this.injector.get('Error');
        this.alert = this.injector.get('Alert');

        this.api = this.injector.get('$http');
        this.depositService = this.injector.get('Deposit');
        this.filter = this.injector.get('$filter');
        this.rootScope = this.injector.get('$rootScope');
        this.queue = this.injector.get('$q');
        this.acl = this.injector.get('Acl');

        this.loading = true;
        this.model = {rsvp: {}, contact: {}};
        this.guestlistInformation = {};
        this.companyProfile = {};
        this.guestlistConfig = null;

        this.deposits = {
            countries: {},
            languages: {},
            genders: {},
            states: {},
            rsvpRelations: []
        };
        this.submitting = false;
        this._init();
    }

    _init() {
        this._loadDeposits();

        this.loadCompanyProfile().then(() => {
            this.contactCustomFields = _(this.companyProfile)
                .map((value, attr) => {
                    if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                        value.key = attr.match(/custom_\d*/gi)[0];
                        return value;
                    }
                })
                .filter()
                .value();
        });

        return this._loadRsvp().then(() => {
            this.rsvpCustomFields = _(this.guestlistInformation)
                .map((value, attr) => {
                    if (attr.match(/custom_\d*_name/gi) && _.keys(value).length) {
                        value.key = attr.match(/custom_\d*/gi)[0];
                        return value;
                    }
                })
                .filter()
                .value();
        });
    }

    _loadRsvp() {
        this.loading = true;
        this.model = {rsvp: {}, contact: {}};

        return this.api.get(`rsvps/${this.rsvpId}?include=guestlist,contact`).then((response) => {
            this.model.rsvp = rsvpModelReducer(_.get(response, 'data.data'), _.get(response, 'data.data.guestlist.data')) /*['guestlist', 'contact']);*/
            this.model.contact = contactModelReducer(_.get(response, 'data.data.contact.data'), this.injector.get('Users').state.company);
            this.guestlistInformation = _.get(response, 'data.data.guestlist.data');

            this.queue.all([
                this._prepareRsvpRelationInformation(),
                this._getGuestlistConfigForSeatplanElements()
            ]).then(() => {
                this.loading = false;
            });
        });
    }

    loadCompanyProfile() {
        return this.api.get(`auth/profile?include=company`).then((response) => {
            this.companyProfile = response.data.data.company.data;
        }, (e) => {
            return e;
        })
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('contacts', 'countries', []).then((value) => {
            this.deposits.countries = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'languages', []).then((value) => {
            this.deposits.languages = value;
        });
        this.depositService.getRemoteDeposit('contacts', 'genders', []).then((value) => {
            this.deposits.genders = value;
        });
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.states = value;
        });
    }

    isFieldEnabled(slug, searchPartial) {
        // const fields = this.model.rsvp.parent_rsvp_id ? this.guestlistInformation.settings.registration_guest_fields : this.guestlistInformation.settings.registration_fields;
        // return (this.filter('filter')(fields, {slug: slug}, !searchPartial).length > 0);
        const enabledFields = this.guestlistInformation.settings.enabled_fields;
        if (searchPartial) {
            for (let i = 0; i < enabledFields.length; i++) {
                if (_.startsWith(enabledFields[i], slug)) {
                    return true;
                }
            }
        } else {
            return enabledFields.indexOf(slug) !== -1;
        }
    }

    save(form) {
        if (!form.$valid) {
            return;
        }
        this.submitting = true;

        if (!this.model.pax_planned || this.model.pax_planned < 1) {
            this.model.pax_planned = 1;
        }

        const contactData = _.clone(this.model.contact),
            rsvpData = _.clone(this.model.rsvp);

        this.api.put(`contacts/${this.model.contact.id}`, contactData).then((response) => {
            const contact = response.data.data;
            rsvpData.contact_id = contact.id;

            this.api.put(`rsvps/${this.model.rsvp.id}`, rsvpData).then((response) => {
                this.modalInstance.close({
                    contact: contact,
                    rsvp: response.data.data
                });
            }, (e) => {
                this.submitting = false;
                this.alert.handle(e);
            }).finally(() => {
                this.submitting = false;
            })
        }, (e) => {
            this.submitting = false;
            this.alert.handle(e);
        });
    };

    cancel() {
        this.modalInstance.dismiss();
    };

    _prepareRsvpRelationInformation() {
        this.deposits.rsvpRelations = [];
        const jobsToWaitFor = [];
        _.each(this.guestlistInformation.rsvp_relation_types, (relationType) => {
            jobsToWaitFor.push(this.api.get(`guestlists/${this.guestlistInformation.id}/available-relations/${relationType.uuid}`).then((response) => {
                this.deposits.rsvpRelations.push({
                    relationType,
                    availableRsvps: _.filter(_.get(response, 'data.data', {}), (v) => {
                        return (v.available || v.id === _.get(this.model.rsvp, `relations.${relationType.uuid}`)) && v.id !== this.model.rsvp.id;
                    })
                });
            }));
        });

        return this.queue.all(jobsToWaitFor);
    }

    handleBoChange(newVal) {
        this.model.rsvp.bookable_objects = newVal;
    }

    _getGuestlistConfigForSeatplanElements() {
        return new Promise((resolve, reject) => {
            const seatplanElementIds = _.map(this.model.rsvp.seatplan_elements, (se) => se.seatplan_element_id);

            this.api.post('guestlists/' + this.model.rsvp.guestlist_id + '/booking-definitions/' + this.model.rsvp.id, {
                elements: seatplanElementIds
            }).then((result) => {
                this.guestlistConfig = result.data;

                if (this.model.rsvp.guestlist_combination_id) {
                    _.each(this.guestlistConfig.available_combinations, (combination) => {
                        if (combination.id === this.model.rsvp.guestlist_combination_id) {
                            this.currentAreaConfigs = combination.areas;
                        }
                    });
                } else {
                    this.currentAreaConfigs = this.guestlistConfig.areas;
                }
                resolve();
            });
        });
    }
}

RsvpQuickEditController.$inject = [
    '$uibModalInstance',
    '$scope',
    '$injector',
    'rsvpId'
];



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/components/extended-info/quick-edit-controller.js